import { render } from "./BottomPagination.vue?vue&type=template&id=fd2f535c&scoped=true&lang=pug"
import script from "./BottomPagination.vue?vue&type=script&lang=js"
export * from "./BottomPagination.vue?vue&type=script&lang=js"

import "./BottomPagination.vue?vue&type=style&index=0&id=fd2f535c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2f535c"]])

export default __exports__